export default function portalCodeName(name)
{
    // First strip everything except letters from the name
    var stripped_name = name.replace(/[^a-z ]/gmi, "").replace(/\ben\b|\voor\b|\with\b|\bfor\b|\bde\b|\bdag\b/gmi, '').replace(/\s+/gm, " "),
        name_parts = stripped_name.trim().split(/\s/),
        return_string = '';

    try {
        switch (name_parts.length) {
            case 1:
                return_string = name_parts[0].substr(0, 4);
                break;

            case 2:
                return_string = name_parts[0].substr(0, 2) + name_parts[1].substr(0, 2);
                break;

            case 3:
                return_string = name_parts[0].substr(0, 1) + name_parts[1].substr(0, 1) + name_parts[2].substr(0, 2);
                break;

            default:
                for (var x = 0; x <= 3; x++) {
                    return_string += name_parts[x].substr(0, 1);
                }
                break;
        }

        return return_string.toUpperCase();
    } catch (e) {
        return '';
    }

};
